import { Box, Container, Paper, Typography } from '@mui/material'
import { useGetOrdersQuery } from 'api/adminSlice'
import { DataTable } from 'modules/common'
import moment from 'moment/moment'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const $COLUMN_WIDTH = 200
export default function AdminOrders() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [page, setPage] = useState(1)

  const { data: Orders, isLoading: OrdersLoaing, isFetching } = useGetOrdersQuery({
    page,
    limit: 100,
  })

  const columns = [
    { field: "orderNumber", sortable: false, headerName: t("Order No."), width: $COLUMN_WIDTH * 1.1 },
    { field: "orderType", valueGetter: ({ value }) => value ? t(`ORDER_TYPES.${value}`) : '-', sortable: false, headerName: t("Order type"), width: $COLUMN_WIDTH * 1.1 },
    { field: "user", valueGetter: ({ value: user }) => `${user?.firstName} ${user?.lastName}`, sortable: false, headerName: t("Client name"), width: $COLUMN_WIDTH * 1.2, },
    { field: "phone", renderCell: ({ row: { user } }) => <bdi>{user?.phone ? user?.phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3') : ''}</bdi>, sortable: false, headerName: t("Client phone"), width: $COLUMN_WIDTH * 1.2, },
    { field: "totalToPay", valueGetter: ({ value }) => t("MONEY", { money: value }), sortable: false, headerName: t("The amount paid"), width: $COLUMN_WIDTH * 1.1 },
    { field: "paymentMethod", valueGetter: ({ value }) => t(`PAYMENT_METHOD.${value}`), sortable: false, headerName: t("Payment method"), width: $COLUMN_WIDTH * 1.1 },
    { field: "currentStatus", valueGetter: ({ value }) => !!value ? t(`ORDER_STATUS.${value}`) : '-', sortable: false, headerName: t("Status"), width: $COLUMN_WIDTH * 1.1 },
    { field: "createdAt", valueGetter: ({ value }) => moment(value).format("DD/MM/YY - h:mm A"), sortable: false, headerName: t("Created At"), width: $COLUMN_WIDTH * 0.8 },
  ];

  const pageChangeHandler = ({ page }) => {
    if (!isFetching) {
      setPage(page)
    }
  }


  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" my={25}>
        <Typography variant='h6'>{t("Orders")}</Typography>
        {/* <SearchTextFiled
          fullWidth
          label={t("Search")}
          size="small"
          value={searchKey ?? ''}
          onChange={onSearchKey}
        /> */}
      </Box>
      <Paper sx={{ height: "80vh" }}>
        <DataTable
          onPaginationModelChange={pageChangeHandler}
          paginationModel={{ page: page - 1, pageSize: 100 }}
          rows={Orders?.docs ?? []}
          columns={columns}
          rowCount={Orders?.totalDocs ?? 0}
          loading={OrdersLoaing || isFetching}
          onRowClick={row => navigate(`/admin/Order/${row?.id}`)}
        />
      </Paper>
    </Container>
  )
}
